import React from 'react';
import PropTypes from 'prop-types';

const TaskBars = ({ tasks, totalHours }) => {
  // Don't render if no tasks or total hours is 0
  if (!tasks || tasks.length === 0 || !totalHours) {
    return null;
  }

  // Additional safety check - ensure all items in the tasks array are objects, not arrays
  const validTasks = tasks.filter(task =>
    typeof task === 'object' && !Array.isArray(task) && task !== null
  );

  if (validTasks.length === 0) {
    return null;
  }

  // Sort tasks by time spent (descending)
  const sortedTasks = [...validTasks].sort((a, b) => b.actualHours - a.actualHours);

  // Only display top 10 tasks
  const tasksToDisplay = sortedTasks.slice(0, 10);

  return (
    <div className="mt-8 mb-4">
      <h3 className="text-lg font-bold mb-2">Time Distribution</h3>
      <div className="space-y-2">
        {tasksToDisplay.map(task => {
          // Safely calculate percentage, avoiding division by zero or undefined values
          const percentage = task.actualHours && totalHours
            ? ((task.actualHours / totalHours) * 100)
            : 0;

          return (
            <div key={task.gid} className="relative">
              <div className="flex justify-between text-sm mb-1">
                <div className="truncate flex-1 mr-2" title={task.name}>
                  {task.name}
                </div>
                <div className="whitespace-nowrap">
                  {task.actualHours?.toFixed(2) || '0.00'} h ({percentage.toFixed(1)}%)
                </div>
              </div>
              <div className="h-2 bg-gray-200 rounded-full overflow-hidden">
                <div
                  className="h-full bg-blue-600 rounded-full"
                  style={{ width: `${percentage}%` }}
                ></div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

TaskBars.propTypes = {
  tasks: PropTypes.arrayOf(
    PropTypes.shape({
      gid: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      actualHours: PropTypes.number.isRequired,
    })
  ).isRequired,
  totalHours: PropTypes.number.isRequired,
};

export default TaskBars;
